










import { PropType } from 'vue';
import { EventRefined } from '@fullcalendar/core/internal';

export default {
  props: {
    eventModel: { type: Object as PropType<EventRefined>, required: true },
  },
  computed: {
    title() {
      const eventType = this.eventModel.extendedProps.type;
      switch (eventType) {
        case 'sum-presence_holiday':
        case 'sum-holiday':
          return this.$t('calendar.holiday');
        case 'sum-vacation_registration':
          return this.$t('calendar.vacation_registration');
        case 'sum-event':
          return this.$t('calendar.events');
        case 'sum-birthday':
          return this.$t('calendar.birthday');
        case 'sum-lesson':
          return this.$t('calendar.lesson');
        case 'sum-parental_meeting':
          return this.$t('calendar.parental_meeting');
        case 'sum-performance_meeting':
          return this.$t('calendar.performance_meeting');
        case 'sum-school_home_meeting':
          return this.$t('calendar.school_home_meeting');
        case 'sum-excursion':
          return this.$t('calendar.excursion');
        case 'sum-other':
          return this.$t('calendar.other_events');
        default:
          return this.eventModel.title;
      }
    },
    count() {
      return this.eventModel.extendedProps.count;
    },
  },
};
